module.exports = __webpack_public_path__ + "static/media/p2p.69ae0a29.svg";